import { render, staticRenderFns } from "./our-benefits.vue?vue&type=template&id=d70d2fc8&scoped=true"
import script from "./our-benefits.vue?vue&type=script&lang=js"
export * from "./our-benefits.vue?vue&type=script&lang=js"
import style0 from "./our-benefits.vue?vue&type=style&index=0&id=d70d2fc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70d2fc8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,Card: require('/var/www/tubber-new/components/global/Card.vue').default})
